import { MachineGuards } from 'common/bento/types/MachineConfig';

import { ApplicationType } from '../../../types';
import { Model } from './model';

export enum Guard {
  CanSeeResetPrompt = 'canSeeResetPrompt',
  ShowNewOnboardingBeneficiaryFlow = 'showNewOnboardingBeneficiaryFlow',
  HasBeneficiaries = 'hasBeneficiaries',
}

const guards: MachineGuards<Model, Guard> = {
  canSeeResetPrompt: ({ getModuleData }) => {
    const { company } = getModuleData().viewer;

    if (!company) {
      return false;
    }

    return company.canResetOnboarding;
  },
  hasBeneficiaries: ({ getModuleData }) => {
    const { company } = getModuleData().viewer;

    // Account owner is counted as a legal beneficiary, which is why we must check for > 1.
    return company.legalBeneficiaries.length > 1;
  },
  showNewOnboardingBeneficiaryFlow: ({ getModuleData }) => {
    const { applicationType, showNewOnboardingBeneficiaryFlow } =
      getModuleData();

    return (
      applicationType === ApplicationType.Standard &&
      showNewOnboardingBeneficiaryFlow
    );
  },
};

export default guards;
